module.exports = __webpack_public_path__ + "media/images/kaoawase/hall-list/kaoawase-halllist-4-2117ddbba71da806c937451471e6f6fa.png";